var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15.5L10.5 15.5M22.5 9.5L10.5 9.5M22.5 21.5L10.5 21.5M6.5 15.5C6.5 16.0523 6.05228 16.5 5.5 16.5C4.94772 16.5 4.5 16.0523 4.5 15.5C4.5 14.9477 4.94772 14.5 5.5 14.5C6.05228 14.5 6.5 14.9477 6.5 15.5ZM6.5 9.5C6.5 10.0523 6.05228 10.5 5.5 10.5C4.94772 10.5 4.5 10.0523 4.5 9.5C4.5 8.94772 4.94772 8.5 5.5 8.5C6.05228 8.5 6.5 8.94772 6.5 9.5ZM6.5 21.5C6.5 22.0523 6.05228 22.5 5.5 22.5C4.94772 22.5 4.5 22.0523 4.5 21.5C4.5 20.9477 4.94772 20.5 5.5 20.5C6.05228 20.5 6.5 20.9477 6.5 21.5Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 14.5L29.5 18.5L32.5 14.5",
    fill: "#475467"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDots);
export default __webpack_public_path__ + "static/media/list-dots.7d6608cd1313abdbb9751fd1da24e935.svg";
export { ForwardRef as ReactComponent };